import React from "react";
import "./style.css";

const Clients = () => {
  return (
    <div>
      <div className="container h-100">
        <div className="row align-items-center h-100">
          <div className="container rounded">
            <h1 className="text-center">Featured in:</h1>
            <div className="slider">
              <div className="logos">
                <i className="fab fa-js fa-4x"></i>
                <i className="fab fa-linkedin-in fa-4x"></i>
                <i className="fab fa-dribbble fa-4x"></i>
                <i className="fab fa-medium-m fa-4x"></i>
                <i className="fab fa-github fa-4x"></i>
              </div>
              <div className="logos"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
